export type ConfigPageId =
  | "config"
  | "communications"
  | "appearance"
  | "notifications"
  | "security"
  | "automation"
  | "mcp"
  | "infrastructure"
  | "ai-agents"
  | "advanced";

export const COMMUNICATION_SECTION_KEYS = [
  "messages",
  "broadcast",
  "talk",
  "audio",
  "channels",
] as const;

export const APPEARANCE_SECTION_KEYS = ["__appearance__", "ui", "wizard"] as const;

const NOTIFICATION_SECTION_KEYS = ["__notifications__"] as const;

// Curated Privacy & Security home: the schema-backed security/approvals policy
// sections render here, below the curated status rows (security.ts).
export const SECURITY_SECTION_KEYS = ["security", "approvals"] as const;

export const AUTOMATION_SECTION_KEYS = [
  "commands",
  "hooks",
  "bindings",
  "cron",
  "plugins",
] as const;

export const INFRASTRUCTURE_SECTION_KEYS = [
  "gateway",
  "web",
  "browser",
  "nodeHost",
  "canvasHost",
  "discovery",
  "media",
  "acp",
] as const;

export const MCP_SECTION_KEYS = ["mcp"] as const;

export const AI_AGENTS_SECTION_KEYS = [
  "agents",
  "models",
  "skills",
  "tools",
  "memory",
  "session",
] as const;

export const SCOPED_CONFIG_SECTION_KEYS = new Set<string>([
  ...COMMUNICATION_SECTION_KEYS,
  ...APPEARANCE_SECTION_KEYS,
  ...NOTIFICATION_SECTION_KEYS,
  ...SECURITY_SECTION_KEYS,
  ...AUTOMATION_SECTION_KEYS,
  ...INFRASTRUCTURE_SECTION_KEYS,
  ...MCP_SECTION_KEYS,
  ...AI_AGENTS_SECTION_KEYS,
]);

// "config" (the curated General hub) and "advanced" render without an include
// list: General shows no schema sections at all, Advanced shows every section
// that has no curated home (config-page computes its exclude list).
const CONFIG_SECTION_KEYS_BY_PAGE = {
  config: undefined,
  communications: COMMUNICATION_SECTION_KEYS,
  appearance: APPEARANCE_SECTION_KEYS,
  notifications: NOTIFICATION_SECTION_KEYS,
  security: SECURITY_SECTION_KEYS,
  automation: AUTOMATION_SECTION_KEYS,
  mcp: MCP_SECTION_KEYS,
  infrastructure: INFRASTRUCTURE_SECTION_KEYS,
  "ai-agents": AI_AGENTS_SECTION_KEYS,
  advanced: undefined,
} as const satisfies Record<ConfigPageId, readonly string[] | undefined>;

export function configSectionKeysForPage(pageId: ConfigPageId): readonly string[] | undefined {
  return CONFIG_SECTION_KEYS_BY_PAGE[pageId];
}
